import { Component } from 'react';
import { rejectParticipantDesktop } from '../../av-moderation/actions';
import { MEDIA_TYPE as AVM_MEDIA_TYPE } from '../../av-moderation/constants';
import { isEnabledFromState } from '../../av-moderation/functions';
import { MEDIA_TYPE } from '../../base/media/constants';
import { muteRemote } from '../actions';
/**
 * Abstract dialog to confirm a remote participant desktop mute action.
 *
 * @augments Component
 */
export default class AbstractMuteRemoteParticipantsDesktopDialog extends Component {
    /**
     * Initializes a new {@code AbstractMuteRemoteParticipantsDesktopDialog} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once per instance.
        this._onSubmit = this._onSubmit.bind(this);
    }
    /**
     * Handles the submit button action.
     *
     * @private
     * @returns {boolean} - True (to note that the modal should be closed).
     */
    _onSubmit() {
        const { dispatch, participantID } = this.props;
        dispatch(muteRemote(participantID, MEDIA_TYPE.SCREENSHARE));
        dispatch(rejectParticipantDesktop(participantID));
        return true;
    }
}
/**
 * Maps (parts of) the redux state to the associated
 * {@code AbstractDialogContainer}'s props.
 *
 * @param {IReduxState} state - The redux state.
 * @private
 * @returns {Object}
 */
export function abstractMapStateToProps(state) {
    return {
        isModerationOn: isEnabledFromState(AVM_MEDIA_TYPE.DESKTOP, state)
    };
}
